import React, { useEffect } from 'react';
import { TReportCreate } from '../../definitions';
import { reportSchema } from '../components/edit-report/schema';
import { Formik } from 'formik';
import store from '../../../../core/redux/store';
import Grid from '@material-ui/core/Grid';
import { useDispatch } from 'react-redux';
import { getUsersAction } from '../../../users/presentation/redux/actions/user-actions';
import { BackNavigationComponent } from '../../../../core/routes/components/back-navigation-component';
import { createReport } from '../../network/create-report.network';
import { useHistory } from 'react-router-dom';
import { createReportStyles } from '../components/create-report/styles';
import Paper from '@material-ui/core/Paper';
import CreateReportForm from '../components/create-report/create-report-form';

export default function CreateReportPage() {
  const classes = createReportStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  const state = store.getState();
  const token = state.token.token;

  const submit = async (values: TReportCreate) => {
    await createReport(token, values);
    history.goBack();
  };

  useEffect(() => {
    if (!token) return;

    dispatch(getUsersAction());
  }, [token]);

  return (
    <Grid
      container
      className={classes.root}
      spacing={2}
      direction="column"
      justify="center"
      alignItems="center"
    >
      <BackNavigationComponent
        page={`Create Report`}
        uri={`/reports/create`}
        path={[
          { page: 'Home', uri: '/' },
          { page: 'Reports', uri: '/reports' }
        ]}
      />

      <Formik
        initialValues={
          {
            name: '',
            link: '',
            users: []
          } as TReportCreate
        }
        validationSchema={reportSchema}
        onSubmit={submit}
      >
        {(props) => (
          <Grid className={classes.container}>
            <Paper className={classes.paper} elevation={4}>
              <CreateReportForm {...props} />
            </Paper>
          </Grid>
        )}
      </Formik>
    </Grid>
  );
}
